import { useCallback } from "react";
import { runOnUI } from "@-/com.npmjs.react-native-reanimated";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import {
  advanceSlideView,
  placeSlideView,
  returnSlideView,
} from "@-/dev.improve.haniverse.routes.nav.app.learn._lib.card-gestures";

import { SlideLessonPageContext } from "#slide-lesson-page-context";

/**
 * Turn the slide to `page`: the next view uncovers as the top one leaves to the left (Next, Redo),
 * the previous view returns from the side it left by (Undo), and any other jump (a re-cut slide
 * with fewer views) lands at once.
 */
export function useGoToSlidePage(): (page: number) => void {
  const [currentPage, setCurrentPage, views] = useContextSelectors(
    SlideLessonPageContext,
    (c) => c.currentPage,
    (c) => c.setCurrentPage,
    (c) => c.views,
  );
  return useCallback(
    (page: number) => {
      // A press during a view's flight turns from the view already on top: nothing waits for it.
      if (page === currentPage + 1) {
        runOnUI(advanceSlideView)(views, page);
      } else if (page === currentPage - 1) {
        runOnUI(returnSlideView)(views, page);
      } else {
        runOnUI(placeSlideView)(views, page);
      }
      setCurrentPage(page);
    },
    [currentPage, setCurrentPage, views],
  );
}
